export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.isCustomizeUserAuthenticationVisible = this.is(
            'computer-login',
            'linux-ssh',
            'radius',
            'cisco-asa',
            'check-point',
            'custom',
            'computer-protection-without-ad',
            'google-apps',
            'owa',
        );
    }

    is(...types) {
        return types.includes(this.application.applicationType.slug);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/application-users.controller.js